import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { get } from 'lodash';

import { YardTaskAttachmentAction } from '@nova/core';

import useYardTaskEvent from './useYardTaskEvent';
import { getAttachmentAction } from './useYardTaskAttachmentEvent.helpers';

import type { YardTaskTimelineEvent } from './types';
import type { UseYardTaskEventOptions } from './useYardTaskEvent';

/**
 * @param {YardTaskTimelineEvent} event
 * @param {UseYardTaskEventOptions} options
 */
export function useYardTaskAttachmentEvent(
  event: YardTaskTimelineEvent,
  options: UseYardTaskEventOptions
) {
  const { t } = useI18n();
  const baseEventData = useYardTaskEvent(event, options);

  const action = computed(() => getAttachmentAction(event));
  const isRemoval = computed(() => action.value === YardTaskAttachmentAction.REMOVED);

  const leadIn = computed(() =>
    isRemoval.value ? t('global.timeline.removedTask') : t('global.timeline.updatedTheTask')
  );

  // Recorded on the event itself; a removed attachment is gone from every document read.
  const fileName = computed<string | null>(() => get(event, 'data.data.name') ?? null);

  return {
    ...baseEventData,
    action,
    isRemoval,
    leadIn,
    fileName
  };
}
